import { useRouter } from "next/router";
function useCheckAdmin() {
  var _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  return pathname === "/admin";
}
export default useCheckAdmin;